import { render, staticRenderFns } from "./ClientIntergrations.vue?vue&type=template&id=94184f78"
import script from "./ClientIntergrations.vue?vue&type=script&lang=js"
export * from "./ClientIntergrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports